const ChatMoreLoading = {
  install: (Vue) => {
    Vue.component('ChatSwitchButton', () => {
      return import('./components/SwitchButton.vue')
    })
  }
}

export default ChatMoreLoading
